import React, { Component } from 'react';
import Imagemodal from '../../../FeedContainer/FeedImage/Imagemodal';
import iconHelper from '../../../../helpers/iconHelper';
import App from "../../../FeedContainer/FeedImage/demo/App";
import "./UserGallery.css";



class UserDedicate extends Component {

    constructor(props) {
      super(props);
  
      this.state = {
        currentActiveImage : null
      };
      this.openDedicateLightBox = this.openDedicateLightBox.bind(this);
    }

    openDedicateLightBox(index){
      this.setState({
        currentActiveImage : index
      })
    }
    
  
    render() {
      
    const {dedicateList} = this.props.galleryDetails;
    return (
            <div className="container gallery_section">
               <App 
                    currentActiveImage = {this.state.currentActiveImage} 
                    media_details      = {dedicateList} 
                    carousalFeed       = {0}
                    post_my_reaction   = ''
                    post_total_reaction= '0'
                    post_total_comment = '0'
                    post_total_share   = '0' 
                    position           = 'dedicates'
                />

            </div>
        );
    }
  }
  
  export default UserDedicate;
